// extracted by mini-css-extract-plugin
export var cardBox = "repoCard-module--cardBox--7A54Y";
export var cardMiddle = "repoCard-module--cardMiddle--LA8el";
export var linksWrap = "repoCard-module--linksWrap--ehOJ7";
export var repoItem = "repoCard-module--repoItem--v6CpM";
export var repoItemDark = "repoCard-module--repoItemDark--vJVlE";
export var repoItemLight = "repoCard-module--repoItemLight--XMi3z";
export var single = "repoCard-module--single--i0oB8";
export var textWrap = "repoCard-module--textWrap--kYt53";